module.exports = __webpack_public_path__ + "static/media/contentful.b5c1f698.png";